<template>
    <el-dialog title="选择现有稿件" :visible.sync="_visible" width="720px" :close-on-click-modal="false" :close-on-press-escape="false">

        <div v-loading="loading">
            <el-table :data="manuscripts" style="width: 100%" highlight-current-row>
                <el-table-column prop="title" label="标题" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <a class="link" :href="'/manuscripts/'+scope.row.manuscript_id" target="_blank">{{ scope.row.title}}</a>
                    </template>
                </el-table-column>
                <el-table-column prop="created_at" width="150" label="创建时间">
                    <template slot-scope="scope">
                        {{ scope.row.created_at|dateformat('YYYY-MM-DD HH:mm')}}
                    </template>
                </el-table-column>

                <el-table-column label="操作" width="90" prop="_selected" align="center">
                    <template slot-scope="scope">
                        <el-button icon="el-icon-download" size="mini" @click="onSubmit(scope.row)">导入</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <white-space/>

            <el-pagination style="text-align: center;" background layout="prev, pager, next" :total="pagination.total" :current-page="pagination.current_page"
                :page-size="pagination.per_page" @current-change="handleCurrentChange">
            </el-pagination>

        </div>

    </el-dialog>
</template>
<script>
    export default {
        props: {
            visible: {
                type: Boolean,
                default: false,
            },
            cart_ids: {
                type: String,
                default: ''
            },
            taxonomy: {
                type: String,
                default: 'taxonomy'
            }
        },
        computed: {
            _visible: {
                get() {
                    return this.visible
                },
                set() {
                    this.$emit('dialogHidden')
                }
            }
        },
        watch: {
            taxonomy() {
                this.loadManuscripts()
            },
        },
        data() {
            return {
                manuscript_id: null,
                disabled: false,
                manuscripts: [],
                loading: false,
                pagination: {
                    total: 0,
                    per_page: 20,
                    current_page: 1
                },
            }
        },
        mounted() {
            this.load()
        },
        methods: {
            onSubmit(row) {
                this.$emit('change', row);
                this._visible = false;
            },
            handleCurrentChange(page) {
                this.pagination.current_page = page
                this.load()
            },
            load() {
                if (!this.taxonomy) {
                    return false
                }
                this.loading = true
                this.$http
                    .get("manuscripts?taxonomy=" + this.taxonomy + '&page=' + this.pagination.current_page)
                    .then(response => {
                        if (response.success) {
                            this.manuscripts = response.data
                            this.pagination = response.pagination
                        }
                    }).catch().then(() => {
                        this.loading = false
                    })
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/manuscript/Import.vue